import * as Yup from 'yup';

export const InitialFeedbackSchema = Yup.object().shape({
  rating: Yup.number()
    .required('Rating is required')
    .min(1, 'Rating must be at least 1')
    .max(10, 'Rating cannot exceed 10'),
  likes: Yup.string().required('Please tell us what you like about us'),
  improvements: Yup.string().required('Please tell us what could be improved'),
});

export type InitialFeedbackDataType = Yup.InferType<
  typeof InitialFeedbackSchema
>;

export const initialFeedbackInitialValues: InitialFeedbackDataType = {
  rating: 0,
  likes: '',
  improvements: '',
};

export const MonthlyFeedbackSchema = Yup.object().shape({
  rating: Yup.number()
    .required('Rating is required')
    .min(1, 'Rating must be at least 1')
    .max(10, 'Rating cannot exceed 10'),
  ratingReason: Yup.string().required(
    'Please tell us why you gave the above rating'
  ),
});

export type MonthlyFeedbackDataType = Yup.InferType<
  typeof MonthlyFeedbackSchema
>;

export const MonthlyFeedbackInitialValues: MonthlyFeedbackDataType = {
  rating: 0,
  ratingReason: '',
};
